<!-- 选择宝箱奖励弹窗 -->
<template lang="pug">
.select-reward-popup-mask(
  v-if="visible"
  @click.self="handleClose"
  @touchmove.prevent v-platform-expose="popupExpose"
)
  .popup-container
    img.popup-title(
      src="https://m.hellobike.com/91d3c3b7_new_title.png"
    )
    .popup-select
      .popup-select-left(v-platform-expose="handleBaseExpose")
        span.popup-reward-number {{ normalBoxReward }}
        .popup-type 宝箱奖励
        .popup-btn-left(
          @click="handleConfirm('base')"
        ) 选{{ normalBoxReward }}奖励金
      .popup-select-right(v-platform-expose="handleVideoExpose")
        span.popup-reward-number.right-amount {{ videoBoxReward }}
        .popup-type 看视频领
        .popup-btn-right(
          @click="handleConfirm('video')"
        ) 选{{ videoBoxReward }}奖励金
          img.corner(
            src="https://m.hellobike.com/f170264c_new_corner.png"
          )
    img.popup-close(
      src="https://m.hellobike.com/ca36acbe_close_popup.png"
      @click="handleClose"
      v-platform-expose="handleCloseExpose"
    )
</template>

<script>
import SPM from '../../../common/spm';

export default {
  name: 'SelectRewardPopup',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    normalBoxReward: {
      type: Number,
      default: 0,
    },
    videoBoxReward: {
      type: Number,
      default: 0,
    },
    strategyCode: {
      type: String,
      default: '',
    },
  },
  methods: {
    popupExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_boxchoose',
        contentId: 'platform_boxchoose',
        businessInfo: {
          adverlBoxgameAmount: this.videoBoxReward,
          normalBoxgameAmount: this.normalBoxReward,
          boxgamecode: this.strategyCode,
        },
      });
    },
    handleCloseExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_boxchoose_close',
        contentId: 'platform_boxchoose_close',
        businessInfo: {
          boxgamecode: this.strategyCode,
        },
      });
    },
    handleBaseExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_boxchoosebtn',
        contentId: 'platform_boxchoosebtn',
        businessInfo: {
          boxgamecode: this.strategyCode,
          clk_name: `选${this.normalBoxReward}奖励金`,
          boxBtnType: '1',
        },
      });
    },
    handleVideoExpose() {
      SPM.moduleExpose({
        moduleId: 'platform_boxchoosebtn',
        contentId: 'platform_boxchoosebtn',
        businessInfo: {
          boxgamecode: this.strategyCode,
          clk_name: `选${this.videoBoxReward}奖励金`,
          boxBtnType: '2',
        },
      });
    },
    handleClose() {
      SPM.clickButton({
        buttonName: 'platform_boxchoose_close',
        businessInfo: {
          boxgamecode: this.strategyCode,
        },
      });
      this.$emit('close');
    },
    handleConfirm(type) {
      const reward = type === 'base'
        ? this.normalBoxReward
        : this.videoBoxReward;
      SPM.clickButton({
        buttonName: 'platform_boxchoosebtn',
        businessInfo: {
          boxgamecode: this.strategyCode,
          clk_name: `选${reward}奖励金`,
          boxBtnType: type === 'base' ? '1' : '2',
        },
      });
      if (type === 'base') {
        this.$emit('select-base');
      } else {
        this.$emit('select-video');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.select-reward-popup-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;

  .popup-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .popup-title {
      width: 1.96rem;
      height: 0.28rem;
    }

    .popup-select {
      display: flex;

      .popup-select-left {
        width: 1.45rem;
        height: 2.25rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: url(https://m.hellobike.com/67dd0ab3_new_small_left.png);
        background-size: 100% auto;
        background-repeat: no-repeat;

        .popup-btn-left {
          margin-top: 0.2rem;
          width: 1.21rem;
          height: 0.34rem;
          border-radius: 0.08rem;
          border: 1px solid #ff5523;
          color: #ff5325;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 600;
          font-style: semibold;
          font-size: 16px;
        }
      }

      .popup-select-right {
        width: 1.45rem;
        height: 2.25rem;
        margin-left: 0.1rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        background: url(https://m.hellobike.com/5f5563dd_new_small_right.png);
        background-size: 100% auto;
        background-repeat: no-repeat;

        .popup-btn-right {
          position: relative;
          margin-top: 0.2rem;
          width: 1.21rem;
          height: 0.34rem;
          border-radius: 0.08rem;
          background: linear-gradient(90deg, #ff5523 0%, #ff3e36 100%);
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          animation: breathe 1s ease-in-out infinite;
          font-weight: 600;
          font-style: semibold;
          font-size: 16px;

          .corner {
            position: absolute;
            right: 0;
            top: -0.07rem;
            width: 0.32rem;
            height: 0.18rem;
          }
        }
      }

      // 左右选项卡共用的奖励金额和类型样式
      .popup-reward-number {
        margin-top: 0.83rem;
        font-family: 'DIN Alternate Bold', sans-serif;
        font-weight: 700;
        font-size: 0.36rem;
        line-height: 0.36rem;
        color: #ff5c0a;
        text-align: center;
      }

      .right-amount {
        font-size: 0.4rem;
      }

      .popup-type {
        margin-top: 0.16rem;
        font-size: 0.14rem;
        line-height: 0.14rem;
        color: #879099;
      }
    }

    .popup-close {
      margin-top: 0.25rem;
      width: 0.32rem;
      height: 0.32rem;
    }
  }
}

@keyframes breathe {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.05);
  }
}
</style>
